class Observer
  constructor: (id, type, callback) ->
    # Отлавливаем загрузку данных по отображению индикатора
    elementId = document.getElementById(id)

    if elementId
      @elementId = elementId

      if type == 'hide'
        observer = new MutationObserver (mutations) ->
          for mutation in mutations
              if mutation.attributeName == 'style' and mutation.target.style.display == 'none'
                console.log 'Получены новые данные с сервера'
                callback()

        @options =
          attributes: true

      if type == 'aria-hidden'
        observer = new MutationObserver (mutations) ->
          for mutation in mutations
            callback(mutation)

        @options =
          attributes: true
          attributeOldValue: true
          attributeFilter: ['aria-hidden']

      if type == 'dom'
        observer = new MutationObserver (mutations) ->
          for mutation in mutations
            console.log 'dom mutation', mutation
            if mutation.addedNodes.length > 0
              callback(mutation)

        @options =
          childList: true

      if type == 'all'
        observer = new MutationObserver (mutations) ->
          for mutation in mutations
            # console.log mutation
            callback(mutation)

        @options =
          childList: true
          attributes: true
          characterData: true
          subtree: true
      @observer = observer
      @start()

  start: =>
    if @observer
      @observer.observe @elementId, @options

  stop: =>
    if @observer
      @observer.disconnect()

module.exports = Observer